/** Logger utility - simple logging wrapper */

// LogLevel type removed - not used

const isDevelopment = import.meta.env.DEV === true;

/**
 * Get logger instance
 */
export function getLogger(name: string) {
  const prefix = `[${name}]`;

  return {
    debug: (...args: unknown[]) => {
      if (isDevelopment) {
        console.debug(prefix, ...args);
      }
    },
    info: (...args: unknown[]) => {
      console.info(prefix, ...args);
    },
    warn: (...args: unknown[]) => {
      console.warn(prefix, ...args);
    },
    error: (...args: unknown[]) => {
      console.error(prefix, ...args);
    },
  };
}
